import { render, staticRenderFns } from "./EmployerMatchTrueUpFrequencySelect.vue?vue&type=template&id=654b296a&"
import script from "./EmployerMatchTrueUpFrequencySelect.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchTrueUpFrequencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports